import CheckBox from '../../../common/CheckBox'

const SelectConnectorItem = ({
  name,
  description,
  value,
  isMapped,
  onConnectorSelect = () => {},
}) => {
  return (
    <div
      className={`hover:bg-blue-100 flex flex-row items-center bg-white w-full px-4 py-2 border-b border-tracer-dark-blue ${isMapped && 'bg-blue-200'}`}
    >
      <div className={`${isMapped && 'disabled'}`}>
        <CheckBox
          name={'inputName'}
          value={value}
          onChange={() => {
            onConnectorSelect()
          }}
          checked={value}
        />
      </div>
      <div className="w-full pl-4">
        <div className="font-bold">{name}</div>
        <div>{description}</div>
        {isMapped && (
          <div className="text-xs text-red-700">
            This Connector is already mapped
          </div>
        )}
      </div>
    </div>
  )
}

export default SelectConnectorItem
